import yup from 'utils/yup';

export const initialOvertimeAlertData = {
  id: '',
  name: '',
  overtime_type: 'weekly',
  is_before: '',
  alert_time_hour: '' as any,
  send_notification_by_mail: false,
  send_notification_by_push: false,
  user_ids: [] as Array<any>,
  group_ids: [],
};

export const overtimeAlertFormValidation = yup.object().shape({
  name: yup.string().required(),
  overtime_type: yup.string().required(),
  is_before: yup.string().required(),
  alert_time_hour: yup.string().required(),
});
